export const getRandomString = (length = 40) => {
    const arr = new Uint8Array(length / 2);

    // msCrypto is used in IE11
    // @ts-expect-error $TSFixMeError: Property 'msCrypto' does not exist on type 'Window & typeof globalThis'. Did you mean 'Crypto'?
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    (window.crypto || window.msCrypto || notSoCrypto).getRandomValues(arr);
    return Array.from(arr, dec2hex).join('');
};

const dec2hex = (dec: $TSFixMe) => `0${dec.toString(16)}`.substr(-2);

const notSoCrypto = {
    getRandomValues: (array: $TSFixMe) => {
        for (let i = 0, l = array.length; i < l; i++) {
            array[i] = Math.floor(Math.random() * 256);
        }
        return array;
    },
};
